var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { id: "tabContainer" } },
    [
      _c(
        "cargo-up-down-resize",
        {
          staticClass: "app-main-inner section",
          staticStyle: { height: "100%" },
          attrs: {
            "up-style": {
              display: "flex",
              flexDirection: "column",
              paddingBottom: "5px"
            },
            "down-style": {
              display: "flex",
              flexDirection: "column",
              paddingTop: "5px"
            }
          }
        },
        [
          _c(
            "template",
            { slot: "up" },
            [
              _c("div", { staticClass: "section operations" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.cooperateEdit,
                        expression: "cooperateEdit"
                      }
                    ],
                    staticClass: "triggers"
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isEdit,
                            expression: "isEdit"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "1",
                              type: "primary",
                              disabled: _vm.selectedContainerUsage === null
                            },
                            on: { click: _vm.changeSealHandler }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.SealNoChangeAdfterInspection"
                                  )
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "2",
                              type: "primary",
                              disabled: _vm.isAutoLoad
                            },
                            on: { click: _vm.autoLoadHandler }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.AutoAllocation")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "3",
                              type: "primary",
                              disabled: _vm.selectedContainerUsage === null
                            },
                            on: { click: _vm.autoUnloadHandler }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("SeaExport.CleanOutTheLoadingRecord")
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "4",
                              type: "danger",
                              disabled: _vm.selectedContainerUsage === null
                            },
                            on: { click: _vm.deleteContainerHandler }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.DeleteTheLoadingRecord")
                              ) + " "
                            )
                          ]
                        ),
                        _vm.job.uuid
                          ? _c(
                              "el-badge",
                              {
                                staticClass: "item",
                                attrs: { "is-dot": _vm.harbourCheckRead }
                              },
                              [
                                _vm.job.uuid
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "share-button",
                                        attrs: { no: "6", type: "primary" },
                                        on: { click: _vm.harbourCompare }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.DataComparison")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.job.uuid
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "7",
                                  type: "primary",
                                  size: "mini"
                                },
                                on: { click: _vm.harbourSync }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.SynchronizePortData")
                                  ) + " "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.job.uuid
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "copyDoorPoint",
                                  type: "primary",
                                  size: "mini"
                                },
                                on: { click: _vm.copyDoorPointData }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyDoorPoint")) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("div", [
                      _c(
                        "span",
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("SeaExport.CargoQuantityDescription")
                              ) +
                              "：" +
                              _vm._s(_vm.lbTotalDesc.lblContainerDesc) +
                              " " +
                              _vm._s(
                                _vm.$t("SeaExport.TotalNumberOfPackages")
                              ) +
                              "：" +
                              _vm._s(_vm.lbTotalDesc.lbTotalQuantity) +
                              " " +
                              _vm._s(_vm.$t("SeaExport.TotalWeight")) +
                              "：" +
                              _vm._s(_vm.lbTotalDesc.lbTotalWeight) +
                              " " +
                              _vm._s(_vm.$t("SeaExport.TotalCubage")) +
                              "：" +
                              _vm._s(_vm.lbTotalDesc.lbTotalCubage) +
                              " "
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.btnshowAWindow && !_vm.isEdit,
                                  expression: "btnshowAWindow && !isEdit"
                                }
                              ],
                              attrs: { type: "primary" },
                              on: { click: _vm.showAWindowClickHandler }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.ViewAssociatedBusiness")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ]),
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  "config-module": "130115",
                  "grid-options": _vm.gridOptions,
                  "grid-params": _vm.gridParams,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.containerUsages,
                  "wrap-text": true
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: function(params) {
                    return (_vm.gridApi = params.api)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "template",
            { slot: "down" },
            [
              _c("portData-goods-info", {
                ref: "portDataGoodsInfo",
                attrs: {
                  job: _vm.job,
                  "is-editing": _vm.isEditGoods && _vm.isEdit,
                  "is-or-not-display-so-no": true,
                  "is-add-spelling": _vm.job.spelling,
                  "del-po-items-uuids": _vm.delPoItemsUuids,
                  "is-uppercase-by-config": _vm.isUppercaseByConfig,
                  "cooperate-edit": _vm.cooperateEdit
                },
                on: { change: _vm.handleChange }
              })
            ],
            1
          )
        ],
        2
      ),
      _c("seal-number-change-dialog", {
        attrs: {
          visible: _vm.boxNoDialog.visible,
          "prop-form-data": _vm.selectedContainerUsage
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.boxNoDialog, "visible", $event)
          },
          sealCloseHandler: _vm.sealCloseHandler
        }
      }),
      _c("associated-business-dialog", {
        attrs: {
          visible: _vm.associatedBusinessDialog.visible,
          "a-data": _vm.associatedBusinessDialog.aData,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.associatedBusinessDialog, "visible", $event)
          },
          refresh: _vm.refresh
        }
      }),
      _c("compare-harbour-dialog", {
        attrs: {
          visible: _vm.harbourDialog,
          "data-source": _vm.poItems,
          "harbour-source": _vm.sourceList,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            _vm.harbourDialog = $event
          },
          addContainer: _vm.handleAddContainer
        }
      }),
      _c("tab-container-record-link-dialog", {
        attrs: {
          visible: _vm.containerRecordDialog.visible,
          "job-uuid": _vm.job.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.containerRecordDialog, "visible", $event)
          },
          selectTruckingRecordHandler: _vm.selectTruckingRecordHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }